import {
  Button,
  useTheme
} from '@mui/material';

import { useAccessState } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import { SaveMilestoneModal } from 'modules/components/layer17';
import { ActivityHeaderSectionWithFIlterLayout } from 'modules/components/layer32';
import React, { useState } from 'react';


export type ProjectMilestonesHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectMilestonesHeaderSectionProps) => {

  return (
    <ActivityHeaderSectionWithFIlterLayout.FC
      filterRow={<></>}
      actionButtons={<ActionButtonsGroup />}
      title='Project Milestones'
    />
  );
};


type ActionButtonsGroup = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  const access = useAccessState('Milestone');

  return (
    <>
      {isVisible && (
        <SaveMilestoneModal.FC
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
          id=''
        />
      )}
      <Button
        variant='contained'
        color='primary'
        disabled={!access.create}
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='PLUS'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Create Milestone
      </Button>

    </>
  );
};

